class InstructionsController {
  public reloadFinalParameters : boolean = false;
  public reloadTempParameters : boolean = false;
  public reloadInstructionSheets : boolean = false;

  /** @ngInject */
  constructor() {}


  loadFinalRunParameters = () => {
    this.reloadFinalParameters = true;
  }


  loadTempRumParameters = () => {
    this.reloadTempParameters = true;
  }


  loadInstructionSheets = () => {
    this.reloadInstructionSheets = true;
  }

}




export const instructions: angular.IComponentOptions = {
  template: require('./fees.instructions.html'),
  controller: InstructionsController
};



// WEBPACK FOOTER //
// ./src/app/fees/instructions/fees.instructions.ts